// Copyright (c) 2016 Deere & Company

import './new-transfer-dealer.scss';
import React, {PropTypes} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import DealerSearchLink from './dealer-search-link';
import {FormattedMessage} from 'react-intl';
import Modal from '../../shared/state/modal';
import NewTransferDealerDetails from './new-transfer-dealer-details';

const NewTransferDealer = props =>
    <section className='new-transfer-dealer'>
        <div className='responsible-dealer'>
            <div className={`${props.isRequired ? 'asterisk-after' : null}`}>
                <FormattedMessage id={props.label}/>
            </div>
            {props.icon ?
                <DealerSearchLink
                    account={props.dealer.account}
                    accountLookup={props.accountLookup}
                    dealerSearchModal={props.dealerSearchModal}
                    onAccountLookupBlur={props.onAccountLookupBlur}
                    onAccountLookupChange={props.onAccountLookupChange}
                    onDealerSearchViewClick={props.onDealerSearchViewClick}
                    onResetClick={props.onResetClick}
                /> : null}
        </div>
        {props.dealer.account ? <NewTransferDealerDetails dealer={props.dealer}/> : null}
    </section>;

NewTransferDealer.displayName = 'NewTransferDealer';
NewTransferDealer.propTypes = {
    accountLookup: PropTypes.string.isRequired,
    dealer: PropTypes.instanceOf(Dealer).isRequired,
    dealerSearchModal: PropTypes.instanceOf(Modal),
    icon: PropTypes.bool,
    isRequired: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onAccountLookupBlur: PropTypes.func.isRequired,
    onAccountLookupChange: PropTypes.func.isRequired,
    onDealerSearchViewClick: PropTypes.func,
    onResetClick: PropTypes.func.isRequired
};

export default NewTransferDealer;




// WEBPACK FOOTER //
// ./src/product/new-transfer/components/new-transfer-dealer.js